<template>
  <div class="content-container">
    <div class="center-content">
      <h3 v-if="formattedDuration!='TL'" class="grey--text text--darken-2 mb-4">{{formattedDuration}}.</h3>

      <h1 class="text-h4 grey--text">Enjoy your <b>Move</b> Session?</h1>
      <p class="text-h6 grey--text">Sitting for 8 hours a day is as bad for your health as <b>obesity</b> and <b>smoking</b>.</p>
      <p class="text-h6 grey--text">Microcise sends hourly notifications* with <b>move</b>, <b>stretch</b>, and <b>strengthen</b> exercises.</p>
      <p class="text-h6 grey--text">Get Healthier. One minute at a time.</p>

      <p class="text-subtitle-2 grey--text note">*you can opt in or out of these notifications at any time</p>
      <h2 class="text-h4 grey--text text--darken-2">It's easy, convenient and <b>free!</b></h2>

      <div class="button-container">
           <v-btn flat large width="300" color="pink darken-2" outlined @click="$router.push('/auth?action=signUp')">Sign up now</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data: () => ({
    totalWorkoutTime: null
  }),

  created() {

    this.totalWorkoutTime=this.$route.query.totalWorkoutTime

  },
  methods: {
    handleSignUp() {
      // Your sign-up logic here
    },


  },
  computed: {
    formattedDuration() {

      let seconds = Math.round(this.totalWorkoutTime/10)
      let formattedDuration=""
      if (isNaN(seconds) || seconds < 0) { 
        formattedDuration = "Too Low"; // Handle invalid input
      } else {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

      if (minutes < 1) {
        formattedDuration = "TL";
      } else if (minutes >= 1 && minutes <= 2) {
         formattedDuration = `Well done you just did ${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')} minutes of exercise`;
      } else {
        formattedDuration = `Excellent. You just did ${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')} minutes of exercise`;
      }
        
      }

      return(formattedDuration)
    }
  }
};
</script>

<style>
.content-container {
  display: flex;
  justify-content: center;
  position: relative;
  top: 100px; /* Add 100px spacing from the top */
}

.center-content {
  text-align: center;
  max-width: 600px;
}

.button-container {
  margin-top: 20px;
}

.note {
  font-size: 14px;
  font-style: italic;
}
</style>
